import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KeyCodeWithModifiersClass;
function KeyCodeWithModifiers() {
  if (KeyCodeWithModifiersClass === VOID) {
    class $ {
      constructor(code, alt, ctrl, shift, meta) {
        alt = alt === VOID ? false : alt;
        ctrl = ctrl === VOID ? false : ctrl;
        shift = shift === VOID ? false : shift;
        meta = meta === VOID ? false : meta;
        this.qcy_1 = code;
        this.rcy_1 = alt;
        this.scy_1 = ctrl;
        this.tcy_1 = shift;
        this.ucy_1 = meta;
      }
      toString() {
        return 'KeyCodeWithModifiers(code=' + this.qcy_1 + ', alt=' + this.rcy_1 + ', ctrl=' + this.scy_1 + ', shift=' + this.tcy_1 + ', meta=' + this.ucy_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.qcy_1);
        result = imul(result, 31) + getBooleanHashCode(this.rcy_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.scy_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.tcy_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.ucy_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KeyCodeWithModifiers()))
          return false;
        if (!(this.qcy_1 === other.qcy_1))
          return false;
        if (!(this.rcy_1 === other.rcy_1))
          return false;
        if (!(this.scy_1 === other.scy_1))
          return false;
        if (!(this.tcy_1 === other.tcy_1))
          return false;
        if (!(this.ucy_1 === other.ucy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KeyCodeWithModifiers');
    KeyCodeWithModifiersClass = $;
  }
  return KeyCodeWithModifiersClass;
}
//region block: exports
export {
  KeyCodeWithModifiers as KeyCodeWithModifiersyrb06kjwhumy,
};
//endregion

//# sourceMappingURL=KeyCode.mjs.map
